import { isValidColor } from 'src/utils/color-utils';

/** Blank is allowed; a field that must hold a color adds its own required check. */
export const COLOR_FIELD_RULES = {
  validate: (value: string) =>
    !value.trim() || isValidColor(value.trim()) || 'Enter a valid color (#nnn or #nnnnnn)',
};
